import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { LotteryResponse, Option } from '@/screens/promo-lottery'

import { API_URL } from '@/shared/lib/const/env'
import { ServerResponse } from '@/shared/types/common'

export type FormData = {
	name: string
	email: string
	phone: string
	f?: string
}

export const lotteryApi = createApi({
	reducerPath: 'lotteryApi',
	baseQuery: fetchBaseQuery({
		baseUrl: API_URL,
		credentials: 'include'
	}),
	endpoints: build => ({
		postForm: build.mutation<ServerResponse<LotteryResponse>, FormData>({
			query: formData => ({
				url: '/lottery',
				method: 'POST',
				body: formData
			})
		}),
		getDrumOptions: build.query<Option[], void>({
			query: () => '/lottery',
			transformResponse: (res: ServerResponse<Option[]>) => res.data
		})
	})
})

export const { usePostFormMutation, useGetDrumOptionsQuery } = lotteryApi
